// extracted by mini-css-extract-plugin
export default {"contentBlock":"Card_contentBlock__d+Ktt","title":"Card_title__NKcj5","headline":"Card_headline__adokg","subtitle":"Card_subtitle__x+HBX","lastUpdated":"Card_lastUpdated__jrQd8"};